//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Bus from 'components/bus.js';
import { MU_UPATE_AUTH, MU_UPATE_SCHOOL } from "store/index";
export default {
  data: function data() {
    return {
      scanVisible: false,
      ruleForm: {
        userName: "",
        password: "",
        phone: "",
        captcha: ""
      },
      rules: {
        userName: [{
          required: true,
          message: "请输入用户账号",
          trigger: "change"
        }],
        password: [{
          required: true,
          message: "请输入密码",
          trigger: "change"
        }],
        phone: [{
          required: true,
          message: "请输入手机号",
          trigger: "change"
        }],
        captcha: [{
          required: true,
          message: "请输入验证码",
          trigger: "change"
        }]
      }
    };
  },
  props: {
    isShow: {
      type: Object,
      default: false
    }
  },
  computed: {
    userInfo: function userInfo() {
      return this.$store.state.auth;
    },
    association: function association() {
      return this.$store.state.association;
    }
  },
  created: function created() {
    if (localStorage["userId"] !== undefined) {
      this.$store.dispatch(MU_UPATE_AUTH).then(function (rt) {});
    }

    this.$store.dispatch(MU_UPATE_SCHOOL, {
      id: window.location.href
    });
  },
  watch: {
    isShow: function isShow(val) {
      this.scanVisible = val.isShow;
    }
  },
  methods: {
    enterRegister: function enterRegister() {
      this.$router.push({
        name: 'register'
      });
    },
    // 忘记密码
    rememberPassword: function rememberPassword() {
      this.$router.push({
        name: "password"
      });
    },
    openLoginDialog: function openLoginDialog() {
      this.scanVisible = true;
    },
    login: function login() {
      var _this = this;

      var that = this;
      this.loadingTip(true);
      this.$http.post("/api/XOrg/XLogin/Accountlogin", {
        userName: that.ruleForm.userName,
        userPwd: that.ruleForm.password,
        associationId: that.association.Id
      }).then(function (rst) {
        if (rst && rst.code > 0) {
          if (rst.code === 1) {
            localStorage["userName"] = _this.ruleForm.userName;
            localStorage["userId"] = rst.userId;
          }

          _this.$store.dispatch(MU_UPATE_AUTH).then(function (rt) {
            _this.loadingTip(false); // 登录完获取回登录信息跳转


            _this.scanVisible = false;

            _this.$router.push({
              name: _this.target_()
            });
          });
        } else {
          _this.loadingTip(false);

          _this.$message.warning(rst.msg);
        }
      });
    },
    loadingTip: function loadingTip(is) {
      if (is) {
        this.$loading({
          lock: true,
          text: "正在登录..."
        });
      } else {
        this.$loading({}).close();
      }
    },
    target_: function target_() {
      var Urlname = "videoDetail"; // if (this.$store.state.auth.userType === 1) {
      //   Urlname = "stuBasicInfo";
      // } else if (this.$store.state.auth.userType === 2) {
      //   Urlname = "teaApply";
      // } else if (this.$store.state.auth.userType === 3) {
      //   Urlname = "siteBasicInfo";
      // } else if (this.$store.state.auth.userType === 9) {
      //   Urlname = "systemManager";
      // }

      return Urlname;
    }
  }
};